import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Descriptions,
  Radio,
  Modal,
  Select,
  Space,
  Input,
  Tag,
  Card,
  Row,
  Col,
  Typography,
  Form,
  DatePicker,
  Steps,
  InputNumber,
  Slider,
  Checkbox,
  Switch,
  Progress,
  Spin,
} from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { AiOutlineGoogle } from "react-icons/ai";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Swal from "sweetalert2";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { shippingActions, addressActions, systemActions } from "../../store";
import ghtkApi from "../../api/ghtkApi";
import orderApi from "../../api/orderApi";
import STATUS from "../../consts/status";
import {
  orderStatusGhtk,
  renderOrderStatus,
  renderPaymentMethod,
  renderPaymentStatus,
  renderShippingMethod,
  renderShippingStatus,
  renderShippingStatusV2,
} from "../../utils/orderStatus";
import { currencyFormat } from "../../utils";
import TextArea from "antd/lib/input/TextArea";
import addressApi from "../../api/addressApi";
import voucherApi from "../../api/voucherApi";
import { MdOutlineAttachMoney } from "react-icons/md";
import { RiErrorWarningFill, RiErrorWarningLine } from "react-icons/ri";

import locale from "antd/es/date-picker/locale/vi_VN";

const dateFormat = "DD/MM/YYYY HH:mm:ss";
const dollar = [
  <svg
    width="22"
    height="22"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      d="M8.43338 7.41784C8.58818 7.31464 8.77939 7.2224 9 7.15101L9.00001 8.84899C8.77939 8.7776 8.58818 8.68536 8.43338 8.58216C8.06927 8.33942 8 8.1139 8 8C8 7.8861 8.06927 7.66058 8.43338 7.41784Z"
      fill="#fff"
    ></path>
    <path
      d="M11 12.849L11 11.151C11.2206 11.2224 11.4118 11.3146 11.5666 11.4178C11.9308 11.6606 12 11.8861 12 12C12 12.1139 11.9308 12.3394 11.5666 12.5822C11.4118 12.6854 11.2206 12.7776 11 12.849Z"
      fill="#fff"
    ></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5V5.09199C8.3784 5.20873 7.80348 5.43407 7.32398 5.75374C6.6023 6.23485 6 7.00933 6 8C6 8.99067 6.6023 9.76515 7.32398 10.2463C7.80348 10.5659 8.37841 10.7913 9.00001 10.908L9.00002 12.8492C8.60902 12.7223 8.31917 12.5319 8.15667 12.3446C7.79471 11.9275 7.16313 11.8827 6.74599 12.2447C6.32885 12.6067 6.28411 13.2382 6.64607 13.6554C7.20855 14.3036 8.05956 14.7308 9 14.9076L9 15C8.99999 15.5523 9.44769 16 9.99998 16C10.5523 16 11 15.5523 11 15L11 14.908C11.6216 14.7913 12.1965 14.5659 12.676 14.2463C13.3977 13.7651 14 12.9907 14 12C14 11.0093 13.3977 10.2348 12.676 9.75373C12.1965 9.43407 11.6216 9.20873 11 9.09199L11 7.15075C11.391 7.27771 11.6808 7.4681 11.8434 7.65538C12.2053 8.07252 12.8369 8.11726 13.254 7.7553C13.6712 7.39335 13.7159 6.76176 13.354 6.34462C12.7915 5.69637 11.9405 5.26915 11 5.09236V5Z"
      fill="#fff"
    ></path>
  </svg>,
];

const OrderDetails = (props) => {
  const dispatch = useDispatch();

  let { id } = useParams();
  let navigate = useNavigate();
  const goToPreviousPath = () => {
    navigate(-1);
  };

  const back = () => {
    goToPreviousPath();
  };
  const [order, setOrder] = useState({});
  const [orderGhtk, setOrderGhtk] = useState({});

  const { notes } = useSelector((x) => x.shipping);
  const { lstAddress } = useSelector((x) => x.address);
  const [feeShippingGhtk, setFeeShippingGhtk] = useState(0);

  const { Title, Text } = Typography;
  const [formUserInfo] = Form.useForm();
  const [formAddress] = Form.useForm();
  const [formVoucher] = Form.useForm();
  const [formStatus] = Form.useForm();
  const [formFee] = Form.useForm();
  const [formGhtk] = Form.useForm();
  const [formGhtkShipFee] = Form.useForm();

  const confirm = Modal.confirm;
  const { Step } = Steps;

  const { Option } = Select;
  const [valueFormStatus, setValueFormStatus] = useState({});
  const [valueFormUser, setValueFormUser] = useState({});
  const [valueFormAddress, setValueFormAddress] = useState({});
  const [valueFormVoucher, setValueFormVoucher] = useState({});
  const [valueFormFee, setValueFormFee] = useState({});
  const [valueFormGhtk, setValueFormGhtk] = useState({});

  const [isModalGhtkVisible, setIsModalGhtkVisible] = useState(false);
  const [isModalStatus, setIsModalStatus] = useState(false);
  const [isModalUserInfo, setIsModalUserInfo] = useState(false);
  const [isModalAddress, setIsModalAddress] = useState(false);
  const [isModalStore, setIsModalStore] = useState(false);
  const [isModalRefund, setIsModalRefund] = useState(false);

  const [isEditVoucher, setIsEditVoucher] = useState(false);
  const [isEditFee, setIsEditFee] = useState(false);

  const [addressShipping, setAddressShipping] = useState([]);
  const [lstVoucher, setLstVoucher] = useState([]);

  const [province, setProvince] = useState();
  const [district, setDistrict] = useState();
  const [village, setVillage] = useState();
  const [loadingGthk, setLoadingGthk] = useState(false);

  const setLoading = (status) => {
    dispatch(systemActions.setLoadingSystem(status));
  };

  useEffect(() => {
    getOrder(id);
  }, []);

  useEffect(() => {
    statusStepsCod();
  }, [order]);

  const getOrder = (id) => {
    setLoading(true);
    orderApi.getOrder(id).then((res) => {
      if (res) {
        setOrder(res);
        setLoading(false);

        if (res.postGhtk) {
          getStatusOrderGhtk(res?.ghtk?.label);
        }
      }
    });
  };

  const getVouchers = () => {
    const params = {
      status: true,
      page: 1,
      limit: 100000,
    };
    voucherApi.getVouchers(params).then((res) => {
      if (res?.results) {
        setLstVoucher(res?.results);
      }
    });
  };

  const getStatusOrderGhtk = (orderCode) => {
    ghtkApi.getStatusOrder(orderCode).then((res) => {
      if (res.success) {
        setOrderGhtk(res.order);
      }
    });
  };

  useEffect(() => {
    const params = { page: 1, limit: 1000 };
    dispatch(addressActions.getShippingAddress(params));
  }, []);

  useEffect(() => {
    formAddress.setFieldsValue(valueFormAddress);
  }, [valueFormAddress]);

  useEffect(() => {
    formUserInfo.setFieldsValue(valueFormUser);
  }, [valueFormUser]);

  useEffect(() => {
    formStatus.setFieldsValue(valueFormStatus);
  }, [valueFormStatus]);

  useEffect(() => {
    formVoucher.setFieldsValue(valueFormVoucher);
  }, [valueFormVoucher]);

  useEffect(() => {
    formFee.setFieldsValue(valueFormFee);
  }, [valueFormFee]);

  const getAddressCod = (code, type, isChange) => {
    const params = {
      parent_code: code,
    };
    addressApi.getAddress(params).then((res) => {
      if (res) {
        const data = res;
        if (type === "province") {
          setProvince(data);
          if (isChange) {
            setDistrict([]);
            setVillage([]);
          }
        } else if (type === "district") {
          if (isChange) {
            formAddress.setFieldsValue({
              district: null,
              districtName: null,
              villageName: null,
              village: null,
            });
            setVillage([]);
          }
          setDistrict(data);
        } else if (type === "village") {
          if (isChange) {
            formAddress.setFieldsValue({
              village: null,
              villageName: null,
            });
          }
          setVillage(data);
        }
      }
    });
  };

  const onChangeSelectProvince = (value, name) => {
    getAddressCod(value, "district", true);
    formAddress.setFieldsValue({
      provinceName: name?.children,
    });
    console.log(`selected ${value}`, name?.children);
  };

  const onChangeSelectDistrict = (value, name) => {
    getAddressCod(value, "village", true);
    formAddress.setFieldsValue({
      districtName: name?.children,
    });
    console.log(`selected ${value}`, name?.children);
  };

  const onChangeSelectVillage = (value, name) => {
    formAddress.setFieldsValue({
      villageName: name?.children,
    });
    console.log(`selected ${value}`, name?.children);
  };

  const [province_ghtk, setProvince_Ghtk] = useState([]);
  const [district_ghtk, setDistrict_Ghtk] = useState([]);
  const [village_ghtk, setVillage_Ghtk] = useState([]);

  const [provinceSelect, setProvinceSelect] = useState(null);
  const [districtSelect, setDistrictSelect] = useState(null);
  const [wardSelect, setWardSelect] = useState(null);

  const getShippingAddress_Ghtk = (code, type, isChange) => {
    const params = {
      parent_id: code,
    };
    ghtkApi.getShipping(params).then((res) => {
      if (res.success) {
        const data = res.data;
        const lstAdd = data.map((item) => {
          return { code: item.id.toString(), name: item.name };
        });
        if (type === "province") {
          setProvince_Ghtk(lstAdd);
          if (isChange) {
            setDistrict_Ghtk([]);
            setVillage_Ghtk([]);
          }
        } else if (type === "district") {
          setDistrict_Ghtk(lstAdd);

          if (isChange) {
            formAddress.setFieldsValue({
              district: null,
              districtName: null,
              villageName: null,
              village: null,
            });
            setVillage_Ghtk([]);
          }
        } else if (type === "village") {
          setVillage_Ghtk(lstAdd);
          if (isChange) {
            formAddress.setFieldsValue({
              village: null,
              villageName: null,
            });
          }
        }
      }
    });
  };

  const onChangeSelectProvince_Ghtk = (value, name) => {
    getShippingAddress_Ghtk(value, "district", true);
    formAddress.setFieldsValue({
      provinceName: name?.children,
    });
    // console.log(`selected ${value}`, name?.children);
    setProvinceSelect(name?.children);
  };

  const onChangeSelectDistrict_Ghtk = (value, name) => {
    getShippingAddress_Ghtk(value, "village", true);
    formAddress.setFieldsValue({
      districtName: name?.children,
    });
    // console.log(`selected ${value}`, name?.children);
    setDistrictSelect(name?.children);
  };

  const onChangeSelectVillage_Ghtk = (value, name) => {
    formAddress.setFieldsValue({
      villageName: name?.children,
    });
    // console.log(`selected ${value}`, name?.children);
    setWardSelect(name?.children);
  };

  const confirmOrder = () => {
    confirm({
      title: "Xác nhận lại yêu cầu ĐÔI TRẠNG THÁI đơn hàng!",
      cancelText: "Đóng",
      okText: "Tiếp tục",
      onOk() {
        const payload = {
          status: STATUS.ORDER_CONFIRM,
        };
        updateOrder(payload);
      },
      onCancel() {},
    });
  };

  const cancelOrder = () => {
    confirm({
      title: "Xác nhận yêu cầu HỦY đơn hàng!",
      cancelText: "Đóng",
      okText: "Tiếp tục",
      onOk() {
        const payload = {
          status: STATUS.ORDER_CANCELED,
        };
        updateOrder(payload);
      },
      onCancel() {},
    });
  };

  const updateOrder = (payload) => {
    orderApi.updateOrder(id, payload).then(
      (res) => {
        if (res) {
          toast.success("Cập nhật thành công!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: undefined,
          });
          getOrder(id);
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.data.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log(err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const showModalGhtk = () => {
    setIsModalGhtkVisible(true);
    dispatch(shippingActions.getShipping());
    const addressShip = lstAddress.map((item) => {
      return { id: item.id, name: item.details };
    });
    setAddressShipping(addressShip);

    setValueFormGhtk({
      ship: checkFeeShip(order?.freeDelivery, order?.paymentStatus),
      money: order?.paymentStatus === "0" ? order?.totalAmount : 0,
      total_weight: 0,
    });
  };

  const showModalStatus = () => {
    setValueFormStatus({
      orderCode: order.orderCode,
      status: order.status,
      paymentStatus: order.paymentStatus,
      shippingStatus: order.shippingStatus,
      shippingMethod: order.shippingMethod,
    });

    setIsModalStatus(true);
  };

  const checkFeeShip = (freeDelivery, paymentStatus) => {
    let returnValue = true;
    if (paymentStatus === "1") {
      returnValue = false;
    } else {
      returnValue = !freeDelivery;
    }
    return returnValue;
  };

  const submitChangeStatusRefund = () => {
    const payload = {
      status: "refunded",
    };
    updateOrder(payload);
    closModalStatus();
  };

  const submitChangeStatus = (data) => {
    const payload = {
      status: data.status,
      paymentStatus: data.paymentStatus,
      shippingStatus: data.shippingStatus,
      shippingMethod: data.shippingMethod,
      transportFee: order.transportFee || 0,
    };
    updateOrder(payload);
    closModalStatus();
  };

  const closModalStatus = () => {
    setValueFormStatus();
    formStatus.resetFields();
    setIsModalStatus(false);
  };

  const showModalUserInfo = () => {
    setValueFormUser({
      customerName: order.customerName,
      email: order.email,
      phoneNumber: order.phoneNumber,
      note: order.note || "",
    });
    setIsModalUserInfo(true);
  };

  const submitChangeInfoUser = (order) => {
    const payload = {
      customerName: order.customerName,
      email: order.email,
      phoneNumber: order.phoneNumber,
      note: order?.note || "",
    };
    updateOrder(payload);
    closeModalUserInfo();
  };

  const closeModalUserInfo = () => {
    setValueFormUser();
    formUserInfo.resetFields();
    setIsModalUserInfo(false);
  };

  const showModalAddressInfo = () => {
    if (order.shippingMethod === STATUS.SHIPPING_GHTK) {
      getShippingAddress_Ghtk("", "province", false);
      getShippingAddress_Ghtk(order.address?.province.id, "district", false);
      getShippingAddress_Ghtk(order.address?.district.id, "village", false);
    } else {
      getAddressCod("", "province", false);
      getAddressCod(order.address?.province.id, "district", false);
      getAddressCod(order.address?.district.id, "village", false);
    }

    setValueFormAddress({
      type: order.address?.type,
      details: order.address?.details,
      province: order.address?.province.id,
      district: order.address?.district.id,
      village: order.address?.village.id,
      provinceName: order.address?.province.name,
      districtName: order.address?.district.name,
      villageName: order.address?.village.name,
    });
    setIsModalAddress(true);
  };

  const submitChangeAddress = (data) => {
    const payload = {
      address: {
        type: data.type,
        details: data.details,
        province: {
          name: data.provinceName == null ? "" : data.provinceName,
          id: data.province == null ? "" : data.province,
        },
        district: {
          name: data.districtName == null ? "" : data.districtName,
          id: data.district == null ? "" : data.district,
        },
        village: {
          name: data.villageName == null ? "" : data.villageName,
          id: data.village == null ? "" : data.village,
        },
      },
    };
    console.log(payload);
    updateOrder(payload);
    closModalAddressInfo();
  };

  const closModalAddressInfo = () => {
    setValueFormAddress();
    formAddress.resetFields();
    setIsModalAddress(false);
  };

  const submitOrderGhtk = (data) => {
    const products = order?.items.map((item) => {
      return {
        name: item?.productName,
        quantity: Number(item?.quantity),
        product_code: item?.productId,
      };
    });

    const pickAddress = lstAddress.find((x) => x.id == data.province);
    const note = data?.note.toString();

    if (note.length > 120) {
      Swal.fire({
        title: "Thất bại!",
        text: "Ghi chú dài quá 120 ký tự!",
        icon: "error",
        confirmButtonText: "OK",
      });
      return false;
    }
    const payload = {
      products: products,
      order: {
        id: order?.orderCode,

        pick_name: pickAddress?.name,
        pick_address: pickAddress?.details,
        pick_province: pickAddress?.province?.name,
        pick_district: pickAddress?.district?.name,
        pick_ward: pickAddress?.village?.name,
        pick_street: pickAddress?.street,
        pick_tel: pickAddress?.phone,

        tel: order?.phoneNumber,
        name: order?.customerName,
        address: order?.address?.details,
        province: order?.address?.province?.name,
        district: order?.address?.district?.name,
        ward: order?.address?.village?.name,
        total_weight: 0,
        hamlet: "Khác",
        transport: "road",
        is_freeship: data.ship ? "0" : "1",
        pick_date: moment(data.pick_date).format("YYYY/MM/DD"),
        pick_work_shift: Number(data.pick_work_shift),
        pick_money: data.money,
        total_weight: data?.total_weight,
        note: note,
        value: order?.totalAmount,
        tag: [data?.tag],
      },
    };
    ghtkApi.createOrder(payload).then(
      (res) => {
        if (res.success) {
          Swal.fire({
            title: "Thành Công!",
            text: "Đăng đơn thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalGhtkVisible(false);
          getOrder(id);
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: "Error",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const cancelOrderGhtk = () => {
    confirm({
      title: "Xác nhận yêu cầu HỦY đơn hàng GHTK!",
      cancelText: "Đóng",
      okText: "Tiếp tục",
      onOk() {
        ghtkApi
          .cancelOrderGhtk({ id: order.id, code: orderGhtk.label_id })
          .then(
            (res) => {
              Swal.fire({
                title: res?.message,
                text: "",
                icon: "info",
                confirmButtonText: "OK",
              });
            },
            (err) => {
              console.log("err", err);
              Swal.fire({
                title: "Thất bại!",
                text: "Error",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          );
      },
      onCancel() {},
    });
  };

  const getLabelOrder = () => {
    ghtkApi.getLabelOrder(orderGhtk.label_id).then(
      (res) => {
        // Save the file to the local file system
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${orderGhtk.label_id}.pdf`); // Set the file name
        document.body.appendChild(link);
        link.click();
      },
      (err) => {
        console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: "Error",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const onShowEditFee = () => {
    setValueFormFee({
      transportFee: order.transportFee,
    });
    setIsEditFee(true);
  };

  const submitFee = (value) => {
    const payload = {
      transportFee: value.transportFee,
    };
    updateOrder(payload);
    closeModalFee();
  };

  const closeModalFee = () => {
    setValueFormFee();
    formFee.resetFields();
    setIsEditFee(false);
  };

  const onShowEditVoucher = () => {
    getVouchers();
    if (order.vouchers.length > 0) {
      console.log(order.vouchers[0].voucherId);
      setValueFormVoucher({
        vouchers: order.vouchers[0].voucherId,
      });
    } else {
      setValueFormVoucher({
        vouchers: null,
      });
    }
    setIsEditVoucher(true);
  };

  const submitVoucher = (value) => {
    const data = value.vouchers ? [value.vouchers] : [];
    const payload = {
      vouchers: data,
    };
    updateOrder(payload);
    closeModalVoucher();
  };

  const closeModalVoucher = () => {
    setValueFormVoucher();
    formVoucher.resetFields();
    setIsEditVoucher(false);
  };

  const changeShippingMethod = (value) => {
    if (value === STATUS.SHIPPING_GHTK) {
      submitFee({ transportFee: 30000 });
    } else {
      submitFee({ transportFee: 0 });
      // setIsShippingGhtk(false);
    }
    // form.setFieldsValue({
    //   provinceName: null,
    //   villageName: null,
    //   districtName: null,
    //   province: null,
    //   village: null,
    //   district: null,
    // });

    // setTotalShipping(0)
  };

  const [statusSteps, setStatusSteps] = useState([]);

  const statusStepsCod = () => {
    const listStatus = [
      {
        statusOrder: STATUS.ORDER_CONFIRM,
        status: "wait",
        title: "Xác Nhận",
        description: "Đơn hàng đã được xác nhận",
      },
      {
        statusOrder: STATUS.ORDER_READY,
        status: "wait",
        title: "Chờ lấy hàng",
        description: "Đang chờ lấy hàng",
      },
      {
        statusOrder: STATUS.ORDER_PICKUP,
        status: "wait",
        title: "Đã lấy hàng",
        description: "Đơn vị vận chuyển đã lấy hàng",
      },
      {
        statusOrder: STATUS.ORDER_SHIPPING,
        status: "wait",
        title: "Đang giao hàng",
        description: "Đơn hàng đang đươc giao",
      },
      {
        statusOrder: STATUS.ORDER_DELIVERED,
        status: "wait",
        title: "Đã giao hàng",
        description: "Đơn hàng đã giao thành công",
      },
    ];

    let isExit = false;

    const statusStep = listStatus.map((item) => {
      if (order?.status === item.statusOrder) {
        item.status = "process";
        isExit = true;
      } else if (!isExit) {
        item.status = "finish";
      }
      return item;
    });

    setStatusSteps(statusStep);
  };

  const ViewShipFeeGhtk = () => {
    setIsModalStore(true);
  };

  const onChangeStore = (id) => {
    setLoadingGthk(true);
    if (id) {
      const stockAddress = lstAddress.find((x) => x.id == id);
      const payloadShip = {
        deliver_option: "none",

        province: order?.address?.province?.name,
        district: order?.address?.district?.name,
        ward: order?.address?.village?.name,

        pick_province: stockAddress?.province?.name,
        pick_district: stockAddress?.district?.name,
        pick_ward: stockAddress?.village?.name,
        weight: 0,
      };

      ghtkApi.getFeeGhtk(payloadShip).then((res) => {
        if (res.success) {
          if (res.fee.delivery) {
            setFeeShippingGhtk(res.fee.fee);
            setLoadingGthk(false);
          } else {
            setLoadingGthk(false);
            Swal.fire({
              title: "Thất bại!",
              text: "GTHK chưa hỗ trợ giao hàng đến khu vực này!",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        }
      });
    } else {
      setLoadingGthk(false);
    }
  };

  const CloseViewShipFeeGhtk = () => {
    setIsModalStore(false);
    setFeeShippingGhtk(0);
    formGhtkShipFee.resetFields(null);
  };

  const showRefundPopup = () => {
    Swal.fire({
      title: "Cảnh báo!",
      text: "Đơn hàng này đã ĐƯỢC THANH TOÁN. Nếu VNFARM đã thực hiện hoàn tiền, vui lòng chọn 'Đã hoàn tiền' để cập nhật trạng thái mới!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Đã hoàn tiền",
      cancelButtonText: "Đóng",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        submitChangeStatusRefund();
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };
  return (
    <>
      <div>
        <Card
          bordered={false}
          bodyStyle={{ padding: "0" }}
          className="header-solid h-full ant-list-yes"
          title={
            <>
              <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <div style={{ cursor: "pointer" }}>
                  {order.status === STATUS.ORDER_CANCELED &&
                  order.paymentStatus === STATUS.PAYMENT_PAID ? (
                    <RiErrorWarningLine
                      size={40}
                      color={"red"}
                      onClick={() => {
                        showRefundPopup();
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div>
                  <h6 className="font-semibold m-0">
                    MÃ ĐƠN HÀNG : <b>#{order.orderCode}</b>
                  </h6>
                </div>
              </div>
            </>
          }
          extra={
            <>
              {order.status === STATUS.ORDER_PENDING ? (
                <Space>
                  <Button
                    type="default"
                    icon={<CheckCircleOutlined />}
                    onClick={() => {
                      confirmOrder();
                    }}
                  >
                    Xác nhận đơn hàng
                  </Button>
                  <Button
                    value="large"
                    type="primary"
                    icon={<CloseCircleOutlined />}
                    danger
                    onClick={() => cancelOrder()}
                  >
                    Hủy đơn hàng
                  </Button>
                </Space>
              ) : (
                <> {renderShippingStatusV2(order.status)}</>
              )}

              <></>
            </>
          }
        ></Card>
        <br />
        <Row gutter={[24, 0]}>
          <Col span={24} md={8} className="mb-24">
            <Card
              bordered={false}
              bodyStyle={{ paddingTop: 0 }}
              className="header-solid h-full  ant-list-yes"
              title={<h6 className="font-semibold m-0">Đơn hàng</h6>}
              extra={
                order.status !== STATUS.ORDER_CANCELED &&
                order.status !== STATUS.ORDER_PENDING ? (
                  <div className="col-action">
                    <Button
                      type="link"
                      className="darkbtn"
                      onClick={() => showModalStatus()}
                    >
                      <EditOutlined /> Chỉnh Sửa
                    </Button>
                  </div>
                ) : null
              }
            >
              <Descriptions title="">
                <Descriptions.Item label="Mã đơn hàng" span={3}>
                  #{order.orderCode}
                </Descriptions.Item>
                <Descriptions.Item label="Thạng thái đơn hàng" span={3}>
                  {renderOrderStatus(order.status)}
                </Descriptions.Item>
                <Descriptions.Item label="Ngày tạo" span={3}>
                  {moment(order.orderDate).format(dateFormat)}
                </Descriptions.Item>

                <Descriptions.Item label="Phương thức thanh toán" span={3}>
                  {renderPaymentMethod(order.paymentMethod)}
                </Descriptions.Item>
                <Descriptions.Item label="Thạng thái Thanh Toán" span={3}>
                  {renderPaymentStatus(order.paymentStatus)}
                </Descriptions.Item>
                <Descriptions.Item label="Phương thức vận chuyển" span={3}>
                  {renderShippingMethod(order.shippingMethod)}
                </Descriptions.Item>
                {/* <Descriptions.Item label="Thạng thái vận chuyển" span={3}>
                  {renderShippingStatus(order.shippingStatus)}
                </Descriptions.Item> */}
              </Descriptions>
            </Card>
          </Col>
          <Col span={24} md={16} className="mb-24">
            <Card
              className="header-solid h-full"
              bordered={false}
              title={<h6 className="font-semibold m-0">Thông tin</h6>}
              bodyStyle={{ paddingTop: "0" }}
            >
              <Row gutter={[24, 24]}>
                <Col span={12}>
                  <Card className="card-billing-info" bordered="false">
                    <div className="col-info">
                      <Descriptions
                        title={
                          <>
                            <label>Khách hàng &nbsp;</label>
                          </>
                        }
                      >
                        <Descriptions.Item label="Họ và tên" span={3}>
                          {order.customerName}
                        </Descriptions.Item>

                        <Descriptions.Item label="Email" span={3}>
                          {order.email}
                        </Descriptions.Item>
                        <Descriptions.Item label="Số điện thoại" span={3}>
                          {order.phoneNumber}
                        </Descriptions.Item>
                        <Descriptions.Item label="Ghi chú" span={3}>
                          {order.note}
                        </Descriptions.Item>
                      </Descriptions>
                    </div>
                    <div className="col-action">
                      {order.status !== STATUS.ORDER_CANCELED &&
                      order?.status !== STATUS.ORDER_DELIVERED ? (
                        <Button
                          type="link"
                          className="darkbtn"
                          onClick={() => showModalUserInfo()}
                        >
                          <EditOutlined /> Chỉnh Sửa
                        </Button>
                      ) : null}
                    </div>
                  </Card>
                </Col>
                <Col span={12}>
                  <Card className="card-billing-info" bordered="false">
                    <div className="col-info">
                      <Descriptions
                        title={
                          <>
                            <label>Địa chỉ giao hàng &nbsp;</label>
                            <Tag color="blue">
                              {order.address?.type === "home"
                                ? " Nhà Riêng"
                                : "Công ty"}
                            </Tag>
                          </>
                        }
                      >
                        <Descriptions.Item label="Địa chỉ" span={3}>
                          {order.address?.details}
                        </Descriptions.Item>

                        <Descriptions.Item label="Tỉnh/Thành Phố" span={3}>
                          {order.address?.province.name}
                        </Descriptions.Item>
                        <Descriptions.Item label="Quận/Huyện" span={3}>
                          {order.address?.district.name}
                        </Descriptions.Item>
                        <Descriptions.Item label="Phường/Xã" span={3}>
                          {order.address?.village.name}
                        </Descriptions.Item>
                      </Descriptions>
                    </div>
                    <div>
                      {order.status !== STATUS.ORDER_CANCELED &&
                      order?.status !== STATUS.ORDER_DELIVERED ? (
                        <Button
                          type="link"
                          className="darkbtn"
                          onClick={() => showModalAddressInfo()}
                        >
                          <EditOutlined /> Chỉnh Sửa
                        </Button>
                      ) : null}

                      <br />
                      <Button type="link">
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`https://maps.google.com/maps??f=q&hl=vi&ie=UTF8&oe=UTF8&geocode=&q=${encodeURI(
                            order.address?.details
                          )}+${encodeURI(
                            order.address?.village.name
                          )}+${encodeURI(
                            order.address?.district.name
                          )}+${encodeURI(order.address?.province.name)}`}
                        >
                          <AiOutlineGoogle /> &nbsp; Google Maps
                        </a>
                      </Button>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <Row gutter={[24, 0]}>
          <Col span={24} md={12} className="mb-24">
            <Card
              className="header-solid h-full"
              bordered={false}
              title={<h6 className="font-semibold m-0">Chi tiết đơn hàng</h6>}
              bodyStyle={{ paddingTop: "0" }}
              extra={
                <Space>
                  {order.status !== STATUS.ORDER_PENDING &&
                  order.status !== STATUS.ORDER_CANCELED &&
                  order?.paymentStatus !== "2" &&
                  order.shippingMethod === STATUS.SHIPPING_GHTK &&
                  !order?.ghtk ? (
                    <>
                      <Button type="primary" onClick={() => showModalGhtk()}>
                        <span>Đăng đơn GHTK</span>
                      </Button>
                    </>
                  ) : null}
                  {order?.ghtk ? (
                    <>
                      {" "}
                      <Button
                        type="primary"
                        danger
                        onClick={() => cancelOrderGhtk()}
                        disabled={
                          orderGhtk?.status === -1 || orderGhtk?.status === 5
                            ? true
                            : false
                        }
                      >
                        <span>Hủy đơn GHTK</span>
                      </Button>
                    </>
                  ) : null}
                </Space>
              }
            >
              <div className="ant-list-box table-responsive">
                <table className="width-100">
                  <thead>
                    <tr>
                      <th className="width-5 center">STT</th>
                      <th className="center">Tên sản phẩm</th>
                      <th className="center">Đơn vị thuộc tính</th>
                      <th className="center">Số lượng</th>
                      <th className="center">Giá thành</th>
                      <th className="center">Thành Tiền</th>
                    </tr>
                  </thead>
                  <tbody>
                    {order.items?.map((d, index) => (
                      <tr key={index}>
                        <td className="center">{index + 1}</td>
                        <td>
                          <span>{d.productName}</span>
                        </td>
                        <td className="center">{d.variantName}</td>

                        <td className="center">{d.quantity}</td>
                        <td className="center">
                          <span>{currencyFormat(Number(d.price))} </span>
                        </td>
                        <td className="center">
                          <span className="font-weight-bold">
                            {currencyFormat(Number(d.amount))}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <Row gutter={[24, 0]}>
                <Col span={13} offset={1}>
                  <Descriptions title="">
                    <Descriptions.Item label="Tổng tiền sản phẩm" span={3}>
                      <span className="text-light-dark ">
                        +{" "}
                        {currencyFormat(
                          order.totalAmount ? order.totalAmount : 0
                        )}
                      </span>
                    </Descriptions.Item>

                    <Descriptions.Item label="Phí vẫn chuyển" span={3}>
                      {/* &nbsp; <Tag color="green">GHTK</Tag> &nbsp;  */}
                      <span className="text-light-success">
                        +{" "}
                        {currencyFormat(
                          order.transportFee ? order.transportFee : 0
                        )}
                      </span>
                      {order.status === STATUS.ORDER_PENDING &&
                      order.paymentStatus !== STATUS.PAYMENT_PAID ? (
                        <>
                          {" "}
                          <div className="span-hover" onClick={onShowEditFee}>
                            &nbsp;&nbsp;
                            <EditOutlined />
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Mã giảm giá" span={5}>
                      {order.vouchers?.length > 0 ? (
                        <>
                          <Tag color="orange">{order.vouchers[0].name}</Tag>

                          <span className="text-light-danger">
                            - {currencyFormat(order.vouchers[0].amount)}
                          </span>
                          {order.status === STATUS.ORDER_PENDING &&
                          order.paymentStatus !== STATUS.PAYMENT_PAID ? (
                            <>
                              <div
                                className="span-hover"
                                onClick={onShowEditVoucher}
                              >
                                &nbsp;&nbsp;
                                <EditOutlined />
                              </div>
                            </>
                          ) : null}
                        </>
                      ) : (
                        <>
                          {order.status === STATUS.ORDER_PENDING &&
                          order.paymentStatus !== STATUS.PAYMENT_PAID ? (
                            <>
                              <Tag
                                style={{ cursor: "pointer" }}
                                onClick={onShowEditVoucher}
                              >
                                Thêm mã giảm giá <PlusOutlined />
                              </Tag>
                            </>
                          ) : (
                            <span className="text-light-danger">
                              - {currencyFormat(0)}
                            </span>
                          )}
                        </>
                      )}
                    </Descriptions.Item>
                  </Descriptions>
                </Col>
                <Col span={10} className="mb-24">
                  <Card bordered={false} className="criclebox ">
                    <div className="number">
                      <Row align="middle" gutter={[24, 0]}>
                        <Col xs={18}>
                          <span>Tổng tiền</span>
                          <Title level={3}>
                            {currencyFormat(
                              order.finalAmount ? order.finalAmount : 0
                            )}
                          </Title>
                        </Col>
                        <Col xs={6}>
                          <div className="icon-box">{dollar}</div>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col span={24} md={12} className="mb-24">
            {order.ghtk ? (
              <Card
                bordered={false}
                bodyStyle={{ paddingTop: 0 }}
                className="header-solid h-full  ant-list-yes"
                title={
                  <Space>
                    <h6 className="font-semibold m-0">
                      Trạng thái đơn hàng GHTK
                    </h6>
                    {orderStatusGhtk(orderGhtk?.status, orderGhtk?.status_text)}
                  </Space>
                }
                extra={
                  <Space>
                    <Button type="primary" onClick={() => getLabelOrder()}>
                      <span>In nhãn đơn hàng</span>
                    </Button>
                  </Space>
                }
              >
                <Row gutter={[24, 0]}>
                  <Col span={12}>
                    <Card className="card-billing-info" bordered="false">
                      <div className="col-info">
                        <Descriptions>
                          <Descriptions.Item label="Miễn phí ship" span={3}>
                            <Switch
                              disabled
                              checked={
                                orderGhtk?.is_freeship === 1 ? true : false
                              }
                            />
                          </Descriptions.Item>

                          <Descriptions.Item label="Nhãn đơn hàng" span={3}>
                            <b>{orderGhtk?.label_id}</b>
                          </Descriptions.Item>

                          <Descriptions.Item label="Mã vận đơn" span={3}>
                            <b> {orderGhtk?.partner_id} </b>
                          </Descriptions.Item>
                          <Descriptions.Item label="Ngày tạo đơn" span={3}>
                            {orderGhtk?.created}
                          </Descriptions.Item>

                          <Descriptions.Item label="Ngày lấy đơn" span={3}>
                            {orderGhtk?.pick_date}
                          </Descriptions.Item>

                          <Descriptions.Item label="Ngày vận chuyển" span={3}>
                            {orderGhtk?.deliver_date}
                          </Descriptions.Item>
                          {/* <Descriptions.Item label="Tiền ship" span={3}>
                            ship_money
                          </Descriptions.Item>
                          <Descriptions.Item label="Tiền thu hộ" span={3}>
                            pick_money
                          </Descriptions.Item> */}
                          <Descriptions.Item label="Khối lượng" span={3}>
                            {orderGhtk?.weight}G
                          </Descriptions.Item>
                          <Descriptions.Item label="Ghi chú" span={3}>
                            {orderGhtk?.message}
                          </Descriptions.Item>
                        </Descriptions>
                      </div>
                    </Card>
                  </Col>
                  <Col span={12} className="mb-24">
                    <Card bordered={false} className="criclebox ">
                      <div className="number">
                        <Row align="middle" gutter={[24, 0]}>
                          <Col xs={18}>
                            <span>Phí ship GHTK</span>
                            <Title level={3}>
                              {currencyFormat(orderGhtk?.ship_money ?? 0)}
                            </Title>
                          </Col>
                          <Col xs={6}>
                            <div className="icon-box">{dollar}</div>
                          </Col>
                        </Row>
                      </div>
                    </Card>
                    <br />
                    <Card bordered={false} className="criclebox ">
                      <div className="number">
                        <Row align="middle" gutter={[24, 0]}>
                          <Col xs={18}>
                            <span>Tổng tiền thu hộ</span>
                            <Title level={3}>
                              {currencyFormat(orderGhtk?.pick_money ?? 0)}
                            </Title>
                          </Col>
                          <Col xs={6}>
                            <div className="icon-box">{dollar}</div>
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Card>
            ) : null}
            {order.status !== STATUS.ORDER_PENDING &&
            order.status !== STATUS.ORDER_CANCELED &&
            order.shippingMethod === STATUS.SHIPPING_VNFARM ? (
              <Card
                bordered={false}
                bodyStyle={{ paddingTop: 0 }}
                className="header-solid h-full  ant-list-yes"
                title={
                  <h6 className="font-semibold m-0">Trạng thái vận chuyển</h6>
                }
                extra={
                  <Space>
                    {/* <Button type="primary" onClick={() => getLabelOrder()}>
                      <span>In nhãn đơn hàng</span>
                    </Button> */}
                  </Space>
                }
              >
                <br />
                <br />{" "}
                <Steps progressDot labelPlacement="vertical">
                  {statusSteps.map((item, index) => {
                    return (
                      <Step
                        key={index}
                        status={item.status}
                        title={item.title}
                        description={item.description}
                      />
                    );
                  })}
                </Steps>
              </Card>
            ) : null}
          </Col>
        </Row>

        <Modal
          title="Sửa đơn hàng"
          visible={isModalStatus}
          onOk={formStatus.submit}
          onCancel={() => {
            closModalStatus();
          }}
        >
          <div>
            <Form
              initialValues={valueFormStatus}
              form={formStatus}
              name="basic"
              layout="vertical"
              onFinish={submitChangeStatus}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item label="Mã đơn hàng" name="orderCode">
                <Input disabled />
              </Form.Item>

              <Form.Item
                label="Thạng thái đơn hàng"
                name="status"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn",
                  },
                ]}
              >
                <Select
                  showArrow
                  showSearch
                  size="large"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn..."
                >
                  <Option value={STATUS.ORDER_PENDING}>Chưa xác nhận</Option>
                  <Option value={STATUS.ORDER_CONFIRM}>Đã xác nhận</Option>
                  <Option value={STATUS.ORDER_READY}>Chờ lấy hàng</Option>
                  <Option value={STATUS.ORDER_PICKUP}>Đã lấy hàng</Option>
                  <Option value={STATUS.ORDER_SHIPPING}>Đang giao hàng</Option>
                  <Option value={STATUS.ORDER_DELIVERED}>Đã giao hàng</Option>
                  <Option value={STATUS.ORDER_CANCELED}>Đã hủy</Option>
                  <Option value={STATUS.ORDER_REFUNDED}>Đã hoàn tiền</Option>
                </Select>
              </Form.Item>

              <Form.Item
                label="Thạng thái Thanh Toán"
                name="paymentStatus"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn",
                  },
                ]}
              >
                <Select
                  showArrow
                  showSearch
                  size="large"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn..."
                  disabled={
                    order?.paymentMethod !== "vnfarm" &&
                    order?.paymentStatus === STATUS.PAYMENT_PAID
                      ? true
                      : false
                  }
                >
                  
                  <Option value={STATUS.PAYMENT_PENDING}>Chờ thanh toán</Option>
                  <Option value={STATUS.PAYMENT_PAID}>Đã thanh toán</Option>
                  <Option value={STATUS.PAYMENT_NOT_PAID}>
                    Chưa thanh toán
                  </Option>
                  <Option value={STATUS.PAYMENT_ERROR}>
                    Lỗi
                  </Option>
                </Select>
              </Form.Item>

              <Form.Item
                label="Phương thức vận chuyển "
                name="shippingMethod"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn",
                  },
                ]}
              >
                <Select
                  showArrow
                  showSearch
                  size="large"
                  optionFilterProp="children"
                  // onChange={changeShippingMethod}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn..."
                  disabled={
                    order?.ghtk || order?.status === STATUS.ORDER_DELIVERED
                  }
                >
                  <Option value={STATUS.SHIPPING_VNFARM}>Tự vận chuyển</Option>
                  <Option value={STATUS.SHIPPING_GHTK}>
                    Giao hàng tiết kiệm
                  </Option>
                </Select>
              </Form.Item>
              {/* 
              <Form.Item
                label="Thạng thái vận chuyển "
                name="shippingStatus"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn",
                  },
                ]}
              >
                <Select
                  showArrow
                  showSearch
                  size="large"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn..."
                >
                  <Option value={STATUS.SHIPPING_PENDING}>Chờ xác nhận</Option>
                  <Option value={STATUS.SHIPPING_READY}>Chưa lấy hàng</Option>
                  <Option value={STATUS.SHIPPING_PICKUP}>Đã lấy hàng</Option>
                  <Option value={STATUS.SHIPPING_SHIPPING}>
                    Đang giao hàng
                  </Option>
                  <Option value={STATUS.SHIPPING_DELIVERED}>
                    Đã giao hàng
                  </Option>
                </Select>
              </Form.Item> */}
            </Form>
          </div>
        </Modal>

        <Modal
          title="Sửa thông tin khách hàng"
          visible={isModalUserInfo}
          onOk={formUserInfo.submit}
          onCancel={() => {
            closeModalUserInfo();
          }}
        >
          <div>
            <Form
              initialValues={valueFormUser}
              form={formUserInfo}
              name="basic"
              layout="vertical"
              onFinish={submitChangeInfoUser}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                label="Họ và tên"
                name="customerName"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    type: "email",
                    message: "Email không đúng định dạng!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Số điện thoại"
                name="phoneNumber"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập số điện thoại!",
                  },
                  {
                    pattern: new RegExp(/^[0-9]+$/),
                    message: "Số điện thoại không đúng định dạng!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item label="Ghi chú" name="note">
                <TextArea rows={3} />
              </Form.Item>
            </Form>
          </div>
        </Modal>

        <Modal
          title="Sửa địa chỉ"
          visible={isModalAddress}
          onOk={formAddress.submit}
          onCancel={() => {
            closModalAddressInfo();
          }}
        >
          <div>
            <Form
              initialValues={valueFormAddress}
              form={formAddress}
              name="basic"
              layout="vertical"
              onFinish={submitChangeAddress}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item label="Loại" name="type" required>
                <Radio.Group>
                  <Radio value="home">Nhà riêng</Radio>
                  <Radio value="company">Công ty</Radio>
                </Radio.Group>
              </Form.Item>

              <Form.Item label="Đia chỉ" name="details">
                <Input placeholder="Nhập địa chỉ..." />
              </Form.Item>

              {order.shippingMethod === STATUS.SHIPPING_GHTK ? (
                <>
                  <Form.Item
                    label="Tỉnh/Thành Phố"
                    name="province"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn tỉnh!!",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      optionFilterProp="children"
                      onChange={onChangeSelectProvince_Ghtk}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {province_ghtk == null ||
                      province_ghtk === "undefined" ||
                      province_ghtk === []
                        ? []
                        : province_ghtk.map((item, key) => (
                            <Option key={key} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Quận/Huyện"
                    name="district"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn quận/huyện!",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      onChange={onChangeSelectDistrict_Ghtk}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {district_ghtk == null ||
                      district_ghtk === "undefined" ||
                      district_ghtk === []
                        ? []
                        : district_ghtk.map((item, key) => (
                            <Option key={key} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Phường/Xã"
                    name="village"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn phường/xã!",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      onChange={onChangeSelectVillage_Ghtk}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {village_ghtk == null ||
                      village_ghtk === "undefined" ||
                      village_ghtk === []
                        ? []
                        : village_ghtk.map((item, key) => (
                            <Option key={key} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                </>
              ) : (
                <>
                  <Form.Item
                    label="Tỉnh/Thành Phố"
                    name="province"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn tỉnh!!",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      optionFilterProp="children"
                      onChange={onChangeSelectProvince}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {province == null ||
                      province === "undefined" ||
                      province === []
                        ? []
                        : province.map((item, key) => (
                            <Option key={key} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Quận/Huyện"
                    name="district"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn quận/huyện!",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      onChange={onChangeSelectDistrict}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {district == null ||
                      district === "undefined" ||
                      district === []
                        ? []
                        : district.map((item, key) => (
                            <Option key={key} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Phường/Xã"
                    name="village"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn phường/xã!",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      onChange={onChangeSelectVillage}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {village == null ||
                      village === "undefined" ||
                      village === []
                        ? []
                        : village.map((item, key) => (
                            <Option key={key} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                </>
              )}

              <Form.Item hidden={true} label="provinceName" name="provinceName">
                <Input />
              </Form.Item>
              <Form.Item hidden={true} label="districtName" name="districtName">
                <Input />
              </Form.Item>
              <Form.Item hidden={true} label="villageName" name="villageName">
                <Input />
              </Form.Item>
            </Form>
          </div>
        </Modal>

        <Modal
          title="Sửa vouchers"
          visible={isEditVoucher}
          onOk={formVoucher.submit}
          onCancel={() => {
            closeModalVoucher();
          }}
        >
          <div>
            <Form
              initialValues={formVoucher}
              form={formVoucher}
              name="basic"
              layout="vertical"
              onFinish={submitVoucher}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item label="Mã giảm giá" name="vouchers">
                <Select
                  showArrow
                  showSearch
                  size="large"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn mã giảm giá..."
                  // onChange={onSelectVoucher}
                >
                  <Option value="" dataValue={0}>
                    ---Không chọn---
                  </Option>
                  {lstVoucher == null ||
                  lstVoucher === "undefined" ||
                  lstVoucher === []
                    ? []
                    : lstVoucher.map((item, key) => (
                        <Option
                          key={key}
                          value={item.id}
                          dataValue={item.value}
                        >
                          {item.name}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            </Form>
          </div>
        </Modal>

        <Modal
          title="Sửa phí vận chuyển"
          visible={isEditFee}
          onOk={formFee.submit}
          onCancel={() => {
            closeModalFee();
          }}
        >
          <div>
            <Form
              initialValues={formFee}
              form={formFee}
              name="basic"
              layout="vertical"
              onFinish={submitFee}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                label="Phí vận chuyển"
                name="transportFee"
                tooltip="Để giá trị (0) nếu free ship"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập phí!",
                  },
                ]}
              >
                <InputNumber
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                  addonAfter={<MdOutlineAttachMoney />}
                  defaultValue={0}
                  min={0}
                />
              </Form.Item>
            </Form>
          </div>
        </Modal>

        <Modal
          title="Đăng đơn GHTK"
          visible={isModalGhtkVisible}
          width={800}
          onOk={formGhtk.submit}
          onCancel={() => {
            setIsModalGhtkVisible(false);
          }}
        >
          <div>
            <Form
              initialValues={valueFormGhtk}
              form={formGhtk}
              name="basic"
              layout="vertical"
              onFinish={submitOrderGhtk}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Row gutter={[24, 24]}>
                <Col span={12}>
                  <Form.Item
                    label="Cửa hàng/Kho lấy hàng"
                    name="province"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {addressShipping == null ||
                      addressShipping === "undefined" ||
                      addressShipping === []
                        ? []
                        : addressShipping.map((item, key) => (
                            <Option key={key} value={item.id}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                  <label>Thông tin đơn hàng</label>
                  <br /> <br />
                  <Card className="card-billing-info" bordered="false">
                    <div className="col-info">
                      <Descriptions>
                        <Descriptions.Item label="Giá trị đơn hàng" span={3}>
                          {currencyFormat(
                            order?.totalAmount ? order.totalAmount : 0
                          )}
                        </Descriptions.Item>

                        <Descriptions.Item
                          label="Phí vận chuyển"
                          span={3}
                          tooltip="Phí ship tính cho khách hàng"
                        >
                          {currencyFormat(
                            order?.transportFee ? order.transportFee : 0
                          )}
                        </Descriptions.Item>
                        <Descriptions.Item label="Phí ship GHTK" span={3}>
                          <Tag
                            onClick={() => {
                              ViewShipFeeGhtk();
                            }}
                            color="blue"
                            style={{ cursor: "pointer" }}
                          >
                            Xem phí ship
                          </Tag>
                        </Descriptions.Item>
                      </Descriptions>
                    </div>
                  </Card>{" "}
                  <br />
                  <label>Thông tin người nhận hàng &nbsp;</label>
                  <br /> <br />
                  <Card className="card-billing-info" bordered="false">
                    <div className="col-info">
                      <Descriptions>
                        <Descriptions.Item label="Họ và tên" span={3}>
                          {order?.customerName}
                        </Descriptions.Item>

                        <Descriptions.Item label="Email" span={3}>
                          {order?.email}
                        </Descriptions.Item>
                        <Descriptions.Item label="Số điện thoại" span={3}>
                          {order?.phoneNumber}
                        </Descriptions.Item>

                        <Descriptions.Item label="Địa chỉ" span={3}>
                          {order?.address?.details}
                        </Descriptions.Item>

                        <Descriptions.Item label="Tỉnh/Thành Phố" span={3}>
                          {order?.address?.province?.name}
                        </Descriptions.Item>
                        <Descriptions.Item label="Quận/Huyện" span={3}>
                          {order?.address?.district?.name}
                        </Descriptions.Item>
                        <Descriptions.Item label="Phường/Xã" span={3}>
                          {order?.address?.village?.name}
                        </Descriptions.Item>
                        <Descriptions.Item label="Ghi chú" span={3}>
                          {order?.note}
                        </Descriptions.Item>
                      </Descriptions>
                    </div>
                  </Card>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Thu phí ship"
                    name="ship"
                    required
                    tooltip="Lưu ý với đơn hàng COD và đơn hàng tổng giá trị hơn 300K"
                    valuePropName="checked"
                  >
                    <Switch>Miễn phí ship</Switch>
                  </Form.Item>

                  <Form.Item label="Loại hàng" name="tag">
                    <Radio.Group>
                      <Radio value={1}>Hàng dễ vỡ</Radio>
                      <Radio value={7}>Nông sản thực phẩm</Radio>
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item
                    label="Tổng khối lượng"
                    name="total_weight"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập",
                      },
                    ]}
                  >
                    <InputNumber min={0} addonAfter="Kg" />
                  </Form.Item>
                  <Form.Item
                    label="Tiền thu hộ"
                    name="money"
                    tooltip="Nếu khách đã thanh toán thì tiền thu hộ bằng 0"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập",
                      },
                    ]}
                  >
                    <InputNumber
                      formatter={(value) =>
                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                      addonAfter={<MdOutlineAttachMoney />}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Ngày lấy hàng"
                    name="pick_date"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập",
                      },
                    ]}
                  >
                    <DatePicker placeholder="Chọn..." locale={locale} />
                  </Form.Item>
                  <Form.Item
                    label="Ca lấy hàng"
                    name="pick_work_shift"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      <Option value="3">Buổi tối</Option>
                      <Option value="2">Buổi chiều</Option>
                      <Option value="1">Buổi sáng</Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Ghi chú"
                    name="note"
                    tooltip="Ghi chú cho GHTK khi giao hàng"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập",
                      },
                    ]}
                  >
                    <Select
                      mode="tags"
                      size="large"
                      placeholder="Chọn..."
                      // onChange={handleChange}
                      style={{
                        width: "100%",
                        height: "auto",
                      }}
                    >
                      {notes == null || notes === "undefined" || notes === []
                        ? []
                        : notes.map((item, key) => (
                            <Option key={key} value={item.content}>
                              {item.content}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </Modal>

        <Modal
          title="Phí vận chuyển của GHTK"
          visible={isModalStore}
          onOk={() => {
            CloseViewShipFeeGhtk();
          }}
          onCancel={() => {
            CloseViewShipFeeGhtk();
          }}
          centered
        >
          <div>
            <Form
              // initialValues={valueForm2}
              form={formGhtkShipFee}
              name="basic"
              layout="vertical"
              // onFinish={onFinish2}
              // onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                label="Địa chỉ lấy hàng mặc định"
                tooltip="Chọn địa chỉ kho hàng để tính phí ship"
                name="address"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn ...!",
                  },
                ]}
              >
                <Select
                  showArrow
                  allowClear
                  showSearch
                  size="large"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={onChangeStore}
                  placeholder="Chọn..."
                >
                  {addressShipping == null ||
                  addressShipping === "undefined" ||
                  addressShipping === []
                    ? []
                    : addressShipping.map((item, key) => (
                        <Option key={key} value={item.id}>
                          {item.name}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            </Form>
          </div>
          <Spin className="mt-10" spinning={loadingGthk}>
            {feeShippingGhtk === 0 ? (
              <></>
            ) : (
              <Card bordered={false} className="criclebox ">
                <div className="number">
                  <Row align="middle" gutter={[24, 0]}>
                    <Col xs={18}>
                      <span>Phí ship GHTK</span>
                      <Title level={3}>{currencyFormat(feeShippingGhtk)}</Title>
                    </Col>
                    <Col xs={6}>
                      <div className="icon-box">{dollar}</div>
                    </Col>
                  </Row>
                </div>
              </Card>
            )}
          </Spin>
          <br />
        </Modal>
      </div>
      <ToastContainer />
    </>
  );
};

export default OrderDetails;
